<template>
    <div class="surgaltiinbaiguullaga">
       <div class="container">
         <div class="surgaltiinbaiguullaga_title">
           <div class="row">
             <div class="col-md-12">
               <div class="left">
                 <h3>Сургалтын төв</h3>
               </div>
             </div>
           </div>
         </div>
         <div class="surgaltiinbaiguullaga_tab">

         <div class="tab_input">
<!--           <div class="row">-->
<!--             <div class="col-6 col-md-6"><h4>Нийт: {{total | number}}</h4></div>-->
<!--             <div class="col-6 col-md-6">-->
<!--               <div class="search-section">-->
<!--                 <Input @on-search="calldata"  search enter-button placeholder="Хайх..." v-model="searchWord"/>-->
<!--               </div>-->
<!--             </div>-->
<!--           </div>-->
           <div class="row">
             <div class="col-md-6">
               <h4>Нийт: {{ total | number }}</h4>
             </div>
             <div class="col-md-3">
               <div class="search-section">
                 <Input @on-search="calldata"  search placeholder="Хайх..." v-model="searchWord"/>
               </div>
             </div>
             <div class="col-md-3">
               <div class="search-section">
                 <Select v-model="orderTypePre"  @on-change="changeOrder">
                   <Option v-for="item in orders" :value="item.value" :key="item.value" >{{ item.label }}</Option>
                 </Select>
               </div>
             </div>
           </div>
         </div>
         <div class="row">
             <div class="col-md-3">
               <div class="main_left">
                 <h3>СУРГАЛТЫН ТӨВ</h3>
                 <a href="javascript:void(0)" @click="cleanFilter" class="clean_button"><i class="fa fa-refresh"></i></a>
                 <div class="list">
                   <Select v-model="select_mergejil" placeholder="Сургалтын төрөл">
                     <Option v-for="t in mergejils" :value="t.tp_name_id" :key="t.tp_name_id">{{ t.tp_name }}</Option>
                   </Select>
                 </div>
                 <div class="list">
                   <Select v-model="select_salbar" placeholder="Салбар">
                     <Option v-for="t in salbars" :value="t.tp_section_id" :key="t.tp_section_id">{{ t.tp_section }}</Option>
                   </Select>
                 </div>
               </div>
<!--               <div class="main_left">-->
<!--                 <h3>Эрэмбэлэх</h3>-->
<!--                 <div class="list">-->
<!--                   <Select v-model="orderTypePre"  @on-change="changeOrder">-->
<!--                     <Option v-for="item in orders" :value="item.value" :key="item.value" >{{ item.label }}</Option>-->
<!--                   </Select>-->
<!--                 </div>-->
<!--               </div>-->
               <div class="main_left">
                 <h3>Аймаг</h3>
                 <div class="list">
                   <CheckboxGroup v-model="filtered_aimag">
                     <div class="checkbox" :key="index" v-for="(aimag, index) in aimags">
                       <Checkbox :label="aimag.id">{{ aimag.aimagname }}<span></span></Checkbox>
                     </div>
                   </CheckboxGroup>
                 </div>
               </div>
               <div class="haih">
                 <Button class="button" @click="calldata"><i class="fa fa-search"></i>Хайх</Button>
               </div>
             </div>
             <div class="col-md-9">
               <div class="surgaltiinbaiguullaga_table">
                 <div class="row">
                   <div class="col-md-12">
                     <table width="100%">
                       <thead>
                       <tr>
                         <th>№</th>
                         <th>СУРГАЛТЫН ТӨВ</th>
                         <!--                   <th>ӨМЧИЙН ХЭЛБЭР</th>-->
                         <th>АЙМАГ НИЙСЛЭЛ</th>
                         <th>УТАС</th>
                         <th>ХАЯГ</th>
                         <th>ЦАХИМ ХУУДАС</th>
                       </tr>
                       </thead>
                       <tbody>
                       <tr :key="index" v-for="(tuv, index) in surgaltiinTuv">
                         <td>
                           <span v-if="current_page == 1">{{index+1}}</span>
                           <span v-else>{{((current_page-1)*100)+(index+1)}}</span>
                         </td>
                         <td>
                           {{tuv.ner_mn}}
                           <!--                                <div class="baiguulgiin_turul">-->
                           <!--                                    <img src="../../assets/flooop.svg" alt="">-->
                           <!--                                    <p>{{tuv.ner_mn}}</p>-->
                           <!--                                </div>-->
                         </td>
                         <!--                   <td>{{tuv.umchii_helber}}</td>-->
                         <td>{{tuv.aimagname}}</td>
                         <td>{{tuv.utas}}</td>
                         <td class="tooltip_hayg">
                           <Tooltip max-width="300"  :content="tuv.hayag_mn">
                             <div class="hayg">
                               <i class="fa fa-map-marker"></i>
                             </div>
                           </Tooltip>
                         </td>
                         <td><a :href="tuv.link" target="_blank"> Зочлох </a></td>
                       </tr>

                       </tbody>
                     </table>
                   </div>
                 </div>
               </div>
             </div>
         </div>

         <div class="pagenation">
           <Page  @on-change="changePageSurgaltiinBaiguullaga"
                  :current-page="current_page"
                  :page-size="100"
                  :total="total"
           />
         </div>
         </div>
       </div>
    </div>
</template>
<script>
import {getSurgaltTuv} from "../../api/index";

    export default {
        name: 'header',
        components: {

        },
        data () {
            return {
                modal1: false,
                modal2: false,
                surgaltiinTuv: [],
                current_page:1,
                last_page:1,
                total: 0,
                searchWord: null,
                salbars: [],
                mergejils: [],
                aimags: [],
                select_mergejil: null,
                select_salbar: null,
                filtered_aimag: [],
                orders: [
                  {
                    value: 'name-asc',
                    label: 'Сургалтын төвийн нэр А - Я'
                  },
                  {
                    value: 'name-desc',
                    label: 'Сургалтын төвийн нэр Я - А'
                  },
                ],
                order: "ASC",
                orderTypePre: "name-asc",
            }
        },
        mounted () {
            this.calldata();
            this.aimags = window.init.aimag;
            this.salbars = window.init.salbar;
            this.mergejils = window.init.mergejil;
        },
        methods: {
          changeOrder(value) {
            if(value == "name-desc"){
              this.order = 'DESC';
            } else if(value == "name-asc"){
              this.order = 'ASC';
            }
            this.calldata();
          },
          calldata(){
                this.$isLoading(true);
                getSurgaltTuv(this.current_page, {
                  mergejil: this.select_mergejil,
                  salbar: this.select_salbar,
                  aimag: this.filtered_aimag,
                  searchWord: this.searchWord,
                  Order:this.order
                }).then(response=>{
                    this.surgaltiinTuv = response.data.data;
                    this.current_page = response.data.current_page;
                    this.total = response.data.total;
                    //console.log(this.surgaltiinTuv);
                    //console.log(this.current_page);
                    this.$isLoading(false);
                }).catch(error => {
                    this.$Loading.error();
                    console.log('ErrorL ', error);
                });
          },
          cleanFilter() {
            this.select_mergejil =  null;
            this.select_salbar =  null;
            this.filtered_aimag =  [];
            this.calldata();
          },
          changePageSurgaltiinBaiguullaga(page) {
                this.current_page = page;
                this.calldata();
          },
        },
    }
</script>
